import { TbPlayerPlayFilled } from "react-icons/tb";
import "./TopicPracticeButton.scss";

type TopicPracticeButtonProps = {
  topicName: string;
  onClick: (topicName: string) => void;
  label?: string;
};

const TopicPracticeButton = ({
  topicName,
  onClick,
  label = "Practice",
}: TopicPracticeButtonProps) => (
  <button
    type="button"
    className="topic-practice-button"
    onClick={() => onClick(topicName)}
    aria-label={`${label} ${topicName}`}
  >
    <TbPlayerPlayFilled aria-hidden="true" />
    <span className="topic-practice-button__label">{label}</span>
  </button>
);

export default TopicPracticeButton;
